import { Flex, Group, Pill, Text } from '@mantine/core';
import { HiArrowUpRight } from 'react-icons/hi2';
import { useHover } from '@mantine/hooks';
import { useMemo } from 'react';
import { getDisplayDomain, getFaviconUrl, normalizeUrl } from '@/utils/urlDisplay.ts';

type Props = {
  title?: string;
  url: string;
};

const UrlCitationPill = ({ title, url }: Props) => {
  const { hovered, ref } = useHover();

  const baseDomain = useMemo(() => getDisplayDomain(url), [url]);
  const normalizedUrl = useMemo(() => normalizeUrl(url), [url]);
  const faviconUrl = useMemo(() => getFaviconUrl(url), [url]);

  const openInNewTab = () => {
    window.open(normalizedUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Pill
      ref={ref}
      key={url}
      size="xs"
      onClick={openInNewTab}
      style={{
        cursor: 'pointer',
        backgroundColor: hovered ? '#EAEAEA' : '#f1f3f5',
      }}
    >
      <Group
        gap={4}
        wrap="nowrap"
        justify="space-between"
        style={{ width: '100%', minWidth: 0, maxWidth: '100%' }}
        h="100%"
      >
        <img
          src={faviconUrl}
          alt="favicon"
          style={{
            maxHeight: '12px',
            maxWidth: '12px',
            objectFit: 'contain',
            flexShrink: 0,
            borderRadius: '50%',
          }}
        />
        <Flex flex={'1 1 auto'} miw={0} ml={'2px'}>
          <Text size="10px" truncate>
            {title}
          </Text>
          <Text size="10px">{baseDomain}</Text>
        </Flex>

        <HiArrowUpRight size={8} color="#757575" strokeWidth={1.5} style={{ flexShrink: 0 }} />
      </Group>
    </Pill>
  );
};

export default UrlCitationPill;
